import * as React from 'react';

import { Container } from 'types/Watchlist';
import { formatDate } from 'utils/common';
import { DATE_DISPLAY_FORMAT, DEFAULT_HOUR_MINUTE_DISPLAY } from 'pages/TrackAndTrace/config';

interface Props {
  container: Container;
}

export const PickedUp: React.FC<Props> = (props) => {
  const {
    container: { gatedOut },
  } = props;

  const gatedOutDate = gatedOut?.occurred;

  const date =
    gatedOutDate &&
    formatDate(
      gatedOutDate,
      `${DATE_DISPLAY_FORMAT} - ${DEFAULT_HOUR_MINUTE_DISPLAY} z`,
      gatedOut?.timezone
    );

  return (
    <div className="space-y-1">
      <h6 className="uppercase font-medium">Picked Up</h6>
      <div className="space-y-1">
        {gatedOut?.chassis && <h6>Chassis used: {gatedOut?.chassis}</h6>}
        {date && <h6>{date}</h6>}
      </div>
    </div>
  );
};
PickedUp.displayName = 'ContainerTable.PickupCell.PickedUp';
